// extracted by mini-css-extract-plugin
export default {"inputContainer":"TextInput_inputContainer__vbQem","inputDisabled":"TextInput_inputDisabled__mHc13"};